import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Painterdashboard() {
  return (
    <section
      className="painter_dashboard p-100 text_white"
      style={{ background: "#3751FF" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>The Painter’s Dashboard – Sign Up</h2>
            <p>
              Introducing The Painter’s Dashboard – Sign Up & Get Painting Jobs
              Now! Get Painting Jobs Worth Thousands Of Dollars Now
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Painterdashboard;
